







































































































import { defineComponent, ref, computed } from '@vue/composition-api';
import { FCButton, LinkButton } from '@fc/angie-ui';
import Video from '~/components/storyblok/Video/Video.vue';
import FCImage from '~/components/FCImage.vue';
import { blue, white, blueLightest } from '@fc/angie-ui/dist/styles/_js_exports.scss';
import { useStoryblok } from '~/composables/useStoryblok';
import { transformLinkButtonContent } from '~/selectors/selectors';

const colorWhiteList = new Map([
  ['blue', blue],
  ['white', white],
  ['blueLightest', blueLightest],
]);

export default defineComponent({
  name: 'DropDownPreview',
  components: {
    Video,
    FCButton,
    FCImage,
    LinkButton,
  },
  inheritAttrs: false,
  setup(_, context) {
    const {
      dropDowns,
      textColor,
      iconColor,
    } = context?.attrs as any;

    const { renderRichText } = useStoryblok();

    const sections: any = computed(() => dropDowns.map((section: any) => {
      const imageProps = section?.mediaContainer.find(media => media.component === 'PictureResponsive');
      const videoProps = section?.mediaContainer.find(media => media.component === 'Video');
      const cta = (section?.cta || [])[0] || {};

      return {
        index: dropDowns.indexOf(section),
        isExpanded: isExpanded(dropDowns.indexOf(section)),
        animationClass: isExpanded(dropDowns.indexOf(section)) ? 'active' : 'inactive',
        src: {
          mp4VideoUrl: videoProps?.mp4VideoUrl,
          mp4MobileVideoUrl: videoProps?.mp4MobileVideoUrl,
          webmMobileVideoUrl: videoProps?.webmMobileVideoUrl,
          webmVideoUrl: videoProps?.webmVideoUrl,
          firstFrameImage: videoProps?.firstFrameImage,
          filename: imageProps?.Image?.filename,
          alt: imageProps?.Image?.alt,
          rounded: videoProps?.rounded ?? imageProps?.rounded ?? false,
          preload: 'none',
        },
        header: section.header,
        text: renderRichText(section.text),
        ctaBindings: transformLinkButtonContent(cta),
      };
    }));

    const currentIndex = ref(0);
    function isExpanded(index: number) {
      return currentIndex.value === index;
    }

    function toggleExpanded(index: number) {
      currentIndex.value = index;
    }

    const color = computed(() => `fc-text-${textColor}`);
    const getColor = computed(() => colorWhiteList.get(textColor));
    const getIconColor = computed(() => colorWhiteList.get(iconColor));

    return {
      toggleExpanded,
      sections,
      currentIndex,
      dropDowns,
      color,
      getColor,
      getIconColor,
    };
  },
});
